import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e657cf2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "由平安财产保险股份有限公司提供以下服务", -1))
const _hoisted_3 = { class: "content-wrap" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "popup-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup__title" }, "投保须知", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup__body" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "popup__body-content" }, " 您将进入平安投保流程，点击“下一步”后的操作由您与平安之间完成，请先阅读并理解以下内容。 "),
  /*#__PURE__*/_createElementVNode("div", { class: "popup__body-content" }, [
    /*#__PURE__*/_createTextVNode(" 经由该方式投保，极飞无法知悉您是否购买保险以及无法帮您开发票、退保等；"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 保单理赔请拨打平安 95511 报案；"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 更改被保人、保单咨询请联系平安工作人员 15622386628。 ")
  ])
], -1))
const _hoisted_8 = { class: "popup__action" }

import { Popup } from 'vant'
import { Ref, ref } from 'vue'
import { useRouter } from 'vue-router'
import Header from '@/components/Header.vue'
import CellWrap from './components/cell-wrap.vue'

interface ListItem {
  title: string
  url: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'third-party-buy',
  setup(__props) {

const show = ref(false)
const $router = useRouter()
const list = ref([
  {
    title: '无人机第三者责任险 (保额30W)',
    url: 'https://emcs.pa18.com/ust?key=12404280000001095972&appType=01',
  },
  {
    title: '无人机第三者责任险 (保额50W)',
    url: 'https://emcs.pa18.com/ust?key=12404280000001096045&appType=01',
  },
  {
    title: '无人机第三者责任险 (保额70W)',
    url: 'https://emcs.pa18.com/ust?key=12404280000001096044&appType=01',
  },
])
const currenItem: Ref<ListItem | null> = ref(null)
function onContinue() {
  show.value = false
  $router.push({
    name: 'iframe-wrap',
    query: {
      title: currenItem.value.title,
      url: currenItem.value.url,
    },
  })
  // window.open(currenItem.value.url)
}

function beforeBuy(data: ListItem) {
  show.value = true
  currenItem.value = data
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header, { title: "无人机第三者责任险" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "content-item",
            key: index,
            onClick: ($event: any) => (beforeBuy(item))
          }, [
            _createVNode(CellWrap, null, {
              default: _withCtx(() => [
                _createElementVNode("div", null, _toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1024)
          ], 8, _hoisted_4))
        }), 128))
      ])
    ]),
    _createVNode(_unref(Popup), {
      show: show.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((show).value = $event)),
      round: "",
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "popup__action-btn",
              onClick: onContinue
            }, "下一步"),
            _createElementVNode("div", {
              class: "popup__action-btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (show.value = false))
            }, "退出")
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})